const isProduction = process.env.NODE_ENV === "production";

export function registerServiceWorker() {
  if (!isProduction || !("serviceWorker" in navigator)) {
    return;
  }

  window.addEventListener("load", () => {
    const publicUrl = process.env.PUBLIC_URL || "";
    const normalizedPublicUrl = publicUrl.endsWith("/")
      ? publicUrl.slice(0, -1)
      : publicUrl;
    const serviceWorkerUrl = `${normalizedPublicUrl}/service-worker.js`;

    navigator.serviceWorker.register(serviceWorkerUrl, {
      scope: `${normalizedPublicUrl || ""}/`,
    }).catch((error) => {
      console.error("Service worker registration failed:", error);
    });
  });
}
